import React from 'react';

export default function CalendarSidebar({ isMobile, onClose, miniCalendarDate, setMiniCalendarDate, setCurrentDate, filters, onFilterChange, myGroups, selectedGroups, setSelectedGroups }) {
    
    const changeMiniMonth = (dir) => {
        const newDate = new Date(miniCalendarDate);
        newDate.setMonth(newDate.getMonth() + dir);
        setMiniCalendarDate(newDate);
    };

    const renderMiniCalendar = () => {
        const year = miniCalendarDate.getFullYear();
        const month = miniCalendarDate.getMonth();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const firstDayIndex = new Date(year, month, 1).getDay();
        const startDay = firstDayIndex === 0 ? 6 : firstDayIndex - 1; 
        const monthNames = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];

        const days = [];
        for (let i = 0; i < startDay; i++) days.push(<div key={`empty-${i}`} className="text-center p-1"></div>);
        for (let i = 1; i <= daysInMonth; i++) {
            const isToday = new Date().toDateString() === new Date(year, month, i).toDateString();
            days.push(
                <button 
                    key={i} 
                    onClick={() => { setCurrentDate(new Date(year, month, i)); if (isMobile) onClose(); }}
                    className={`text-center p-1 text-xs rounded-full hover:bg-gray-200 transition-colors ${isToday ? 'bg-blue-600 text-white font-bold hover:bg-blue-700' : 'text-gray-700'}`}
                >
                    {i}
                </button>
            );
        }

        return (
            <div className="px-4 py-4">
                <div className="flex justify-between items-center mb-2">
                    <span className="text-sm font-medium text-gray-800">{monthNames[month]} {year}</span>
                    <div className="flex gap-1">
                        <button onClick={() => changeMiniMonth(-1)} className="p-1 rounded hover:bg-gray-100"><svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg></button>
                        <button onClick={() => changeMiniMonth(1)} className="p-1 rounded hover:bg-gray-100"><svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg></button>
                    </div>
                </div>
                <div className="grid grid-cols-7 gap-y-1">
                    {['П', 'В', 'С', 'Ч', 'П', 'С', 'В'].map((d, i) => <div key={i} className="text-center text-[10px] font-medium text-gray-500">{d}</div>)}
                    {days}
                </div>
            </div>
        );
    };

    const colors = ['text-blue-500', 'text-emerald-500', 'text-purple-500', 'text-orange-500', 'text-pink-500'];

    return (
        <div className="flex flex-col h-full bg-white pb-6">
            
            {/* Мобильная шапка с крестиком */}
            {isMobile && (
                <div className="flex justify-between items-center p-4 border-b border-gray-100">
                    <div className="flex items-center gap-2">
                        <div className="w-6 h-6 bg-blue-600 text-white rounded flex items-center justify-center font-bold text-xs">ED</div>
                        <span className="font-semibold text-gray-800">Календарь</span>
                    </div>
                    <button onClick={onClose} className="p-1 text-gray-500 hover:bg-gray-100 rounded-full"><svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg></button>
                </div>
            )}

            <div className="p-4">
                <button className="flex items-center gap-3 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-3 px-5 rounded-full shadow-sm transition-all hover:shadow-md">
                    <svg className="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" /></svg>
                    Создать
                </button>
            </div>

            {renderMiniCalendar()}

            <div className="px-4 py-2 mt-2">
                <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-3">Мои группы</h3>
                <div className="flex flex-col gap-2">
                    {myGroups.map((group, index) => {
                        const isChecked = selectedGroups.includes(group.name);
                        return (
                            <label key={group.id} className="flex items-center gap-3 cursor-pointer group">
                                <input type="checkbox" checked={isChecked} onChange={() => setSelectedGroups(isChecked ? selectedGroups.filter(g => g !== group.name) : [...selectedGroups, group.name])} className={`w-4 h-4 rounded border-gray-300 focus:ring-0 cursor-pointer ${colors[index % colors.length]}`} />
                                <span className="text-sm font-medium text-gray-700 group-hover:text-black">{group.name}</span>
                            </label>
                        );
                    })}
                </div>
            </div>

            <div className="px-4 py-4 mt-2 border-t border-gray-100">
                <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-3">События</h3>
                <div className="flex flex-col gap-2">
                    <label className="flex items-center gap-3 cursor-pointer"><input type="checkbox" checked={filters.personal} onChange={() => onFilterChange('personal')} className="w-4 h-4 rounded text-blue-600" /><span className="text-sm text-gray-700">Личные</span></label>
                    <label className="flex items-center gap-3 cursor-pointer"><input type="checkbox" checked={filters.tests} onChange={() => onFilterChange('tests')} className="w-4 h-4 rounded text-purple-600" /><span className="text-sm text-gray-700">Тесты</span></label>
                    <label className="flex items-center gap-3 cursor-pointer"><input type="checkbox" checked={filters.meetings} onChange={() => onFilterChange('meetings')} className="w-4 h-4 rounded text-green-600" /><span className="text-sm text-gray-700">Встречи</span></label>
                </div>
            </div>
        </div>
    );
}